import type { StyleClassDefinition } from './types';

/**
 * Predefined style classes for slots.
 * CSS variables map to Tailwind theme or custom CSS.
 */
export const STYLE_CLASSES: Record<string, StyleClassDefinition> = {
  'hero-heading': {
    label: 'Hero Heading',
    targetType: 'text',
    cssVars: {
      '--text-size': '3rem', // ~text-5xl
      '--text-weight': '700', // font-bold
      '--text-color': 'var(--color-foreground)',
      '--line-height': '1.1',
    },
  },
  'section-heading': {
    label: 'Section Heading',
    targetType: 'text',
    cssVars: {
      '--text-size': '1.875rem', // ~text-3xl
      '--text-weight': '600', // font-semibold
      '--text-color': 'var(--color-foreground)',
      '--line-height': '1.2',
    },
  },
  'body-text': {
    label: 'Body Text',
    targetType: 'text',
    cssVars: {
      '--text-size': '1rem', // ~text-base
      '--text-weight': '400', // font-normal
      '--text-color': 'var(--color-foreground)',
      '--line-height': '1.6',
    },
  },
  'cta-button': {
    label: 'CTA Button',
    targetType: 'button',
    cssVars: {
      '--bg-color': 'var(--color-primary)',
      '--text-color': 'white',
      '--padding-x': '1.5rem',
      '--padding-y': '0.75rem',
      '--border-radius': '0.5rem',
      '--font-weight': '600',
    },
  },
};

/**
 * Get a style class by ID.
 */
export function getStyleClassById(id: string): StyleClassDefinition | undefined {
  return STYLE_CLASSES[id];
}

/**
 * Get available style classes for a given slot type.
 */
export function getStyleClassesForType(
  type: 'text' | 'image' | 'button'
): StyleClassDefinition[] {
  return Object.entries(STYLE_CLASSES)
    .filter(([_, def]) => def.targetType === type)
    .map(([key, def]) => ({ ...def, id: key }));
}
